import React, { useEffect, useRef, useState } from 'react';
import { X } from 'lucide-react';
import { painPointsData } from '../../data/mock';

const PainPointsSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section 
      ref={sectionRef}
      className="py-32 bg-white relative"
    >
      <div className="max-w-4xl mx-auto px-8 text-center">
        {/* Header */}
        <h2 className={`text-3xl md:text-4xl lg:text-5xl font-normal text-[#202020] mb-6 tracking-tight transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {painPointsData.title}
        </h2>
        <p className={`text-[#202020]/50 text-lg mb-16 transition-all duration-1000 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          Imagine a life where these words no longer escape your lips.
        </p>

        {/* Pain Points */}
        <div className="grid md:grid-cols-2 gap-4">
          {painPointsData.statements.map((statement, index) => (
            <div 
              key={index}
              className={`group flex items-center gap-4 bg-[#efede6] rounded-xl p-5 transition-all duration-500 hover:bg-[#202020] ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
              style={{ transitionDelay: `${(index + 2) * 80}ms` }}
            >
              <X className="w-5 h-5 text-[#202020]/40 flex-shrink-0 group-hover:text-[#efede6]/50 transition-colors" />
              <p className="text-left text-[#202020]/70 line-through decoration-[#202020]/30 group-hover:text-[#efede6]/70 group-hover:decoration-[#efede6]/30 transition-colors">
                {statement}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;
